<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" hide-footer :onClose="onClose">
    <div class="row">
      <div class="col-12 mb-3 mt-1">
        <div class="generalLabel">
          <div>{{ message }}</div>
        </div>
      </div>
      <div class="col-12">
        <div>
          <button
          v-if="!imeiHasChanged"
            class="btn btn-primary generalPrimaryButton float-right"
            @click="addNewImei()"
            >
           <p v-if="!imeiConfirmloading" class="confirmTextButton">CONFIRMAR</p>
            <img v-if="imeiConfirmloading" src="../../../../../assets/loaderPrimary.svg" height="20" alt="" class="btn-imei-loading">
          </button>

          <button
          v-if="imeiHasChanged"
          class="btn btn-primary generalPrimaryButton float-right"
          @click="onClose()"
          >
            CERRAR
        </button>

        </div>
        <button
        v-if="!imeiHasChanged"
          class="btn btn-primary generalPrimaryButton float-right"
          @click="onClose()"
          >
            CANCELAR
        </button>
      </div>
    </div>
    <button :id="id+'CierreModal'" style="display: none;" data-dismiss="modal" />
  </Modal>
</template>
<script>
import Modal from "../../../Shared/Modal.vue";

export default {
  name: "ModalConfirmNewImei",
  props: [
    "id",
    "modalTitle",
    "class",
    "message",
    "imeiConfirmloading",
    "imeiHasChanged"
  ],
  data() {
    return {
      classes: this.class,
    };
  },
  components: {
    Modal,
  },
  methods: {
    onClose() {
      document.querySelector(`#${this.id}CierreModal`).click();
      this.$emit("closeModal", '');
		},
    addNewImei() {
      this.$emit("addNewImei", '');
    }
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.confirmTextButton {
  margin-bottom: 0px;
}

.btn-imei-loading {
  min-width: 100px;
}
</style>
